<template>
  <div>

    <img class="logo" src="../assets/logo5.png">
    <p class="leading">アイリッシュセットダンスをもっと楽しむためのリファレンスサイト<br/>
    （はじめての方は<router-link :to="{ name: 'ForVisitor' }">こちら</router-link>をお読みください）</p>

    <md-subheader>お知らせ</md-subheader>

    <p class="news" v-show="getNews"><md-chip>{{ getNews }}</md-chip></p>

    <md-subheader>ダンスの記事</md-subheader>

    <md-list class="md-double-line">
      <md-list-item
        v-for="article, index in getReversedArticles"
        :key="index">
        <div class="md-list-text-container">
          <span>
            <a :href="article.url" target="_blank">{{ article.title }}</a>
          </span>
          <span
            v-if="article.genre === 'SetDance'"
            class="md-primary type-of-event"
            key="articleSetDance">セットダンス</span>
          <span
            v-else-if="article.genre === 'SeanNos'"
            class="md-accent type-of-event"
            key="articleSeanNos">シャンノース</span>
          <span
            v-else-if="article.genre === 'CeiliDance'"
            class="md-accent type-of-event"
            key="articleSeanNos">ケーリーダンス</span>
          <span
            v-else-if="article.genre === 'OldStyleStepDance'"
            class="md-accent type-of-event"
            key="articleSeanNos">オールドスタイル</span>
          <span
            v-else-if="article.genre === 'ModernStyleStepDance'"
            class="md-accent type-of-event"
            key="articleSeanNos">モダンスタイル</span>
          <span
            v-else-if="article.genre === 'Others'"
            class="md-primary type-of-event"
            key="articleOthers">その他</span>
          <p>
            {{ article.description }} by {{ article.writers }}
          </p>
        </div>
        <!-- <md-chip
          v-if="article.genre === 'SetDance'"
          class="md-primary type-of-event"
          key="articleSetDance">セットダンス</md-chip>
        <md-chip
          v-else-if="article.genre === 'SeanNos'"
          class="md-accent type-of-event"
          key="articleSeanNos">シャンノース</md-chip>
        <md-chip
          v-else-if="article.genre === 'Others'"
          class="md-primary type-of-event"
          key="articleOthers">その他</md-chip> -->
        <md-divider></md-divider>
      </md-list-item>
    </md-list>

    <div class="event-controller">
      <router-link
        tag="md-button"
        :to="{ name: 'AddArticle' }"
        class="md-raised md-primary">記事のリンクを追加する</router-link>
      <router-link
        tag="md-button"
        :to="{ name: 'AllArticles' }"
        class="md-raised">すべての記事をみる</router-link>
    </div>

    <md-subheader>開催予定のイベント</md-subheader>

    <md-list class="md-double-line">
      <md-list-item
        v-for="event, index in events"
        :key="index">
        <div class="md-list-text-container">
          <span>
            <router-link :to="{ name: 'Event', params: { eventId: event.id } }">
              {{ event.name }}
            </router-link>
          </span>
          <span class="jpCaption">
            {{ event.host }}
          </span>
          <p>
            {{ getEventSchedule(event.startTime, event.endTime) }}
          </p>
        </div>
        <md-chip
          v-if="event.type === 'Class'"
          class="md-primary type-of-event"
          key="eventClass">クラス</md-chip>
        <md-chip
          v-else-if="event.type === 'Céilí'"
          class="md-accent type-of-event"
          key="eventCeili">ケーリー</md-chip>
        <md-chip
          v-else-if="event.type === 'SessionOrDance'"
          class="md-primary type-of-event"
          key="eventCeili">セッション/ダンス</md-chip>
        <md-divider></md-divider>
      </md-list-item>
    </md-list>

    <div class="event-controller">
      <router-link
        tag="md-button"
        :to="{ name: 'AddEvent' }"
        class="md-raised md-primary">イベントを作成する</router-link>
      <router-link
        tag="md-button"
        :to="{ name: 'NextEvents' }"
        class="md-raised">その他のイベントをみる</router-link>
    </div>

    <md-subheader>セットリスト</md-subheader>

    <md-input-container md-clearable>
      <md-icon>search</md-icon>
      <md-input v-model="searchKey" @input="searchSet($event)" id="serachField" placeholder="セットを検索する"></md-input>
    </md-input-container>

    <md-list
      v-for="(set, index) in sets"
      :key="index"
      class="md-double-line">
      <md-divider v-if="!existsSubHeader(set.name)"></md-divider>
      <md-subheader v-if="existsSubHeader(set.name)">{{ set.name.substr(0, 1) }}</md-subheader>
      <md-list-item>
        <md-avatar
          class="md-large">
          <router-link :to="{ name: 'Set', params: { setName: set.name }}">
            <img
              :src="set.figures[0].youtube ? getThumbnail(set.figures[0].youtube.url) : getThumbnail(set.thumbnail)"
              alt="Thumbnail" />
          </router-link>
        </md-avatar>
        <div class="md-list-text-container">
          <span>
            <router-link v-if="set.needsSet" :to="{ name: 'Set', params: { setName: set.name }}">
              {{ set.name }} Set
            </router-link>
            <router-link v-else :to="{ name: 'Set', params: { setName: set.name }}">
              {{ set.name }}
            </router-link>
          </span>
          <span v-if="set.needsSet" class="jpCaption">
            {{ set.jpCaption }}・セット
          </span>
          <span v-else class="jpCaption">
            {{ set.jpCaption }}
          </span>
          <p>
            {{ getDescription(set) }}
          </p>
        </div>
      </md-list-item>
    </md-list>
    <md-list>
      <md-list-item>
        <md-avatar
          class="md-large">
          <router-link :to="{ name: 'SoldiersSong' }">
            <img
              src="/static/img/ireland.gif"
              alt="Thumbnail" />
          </router-link>
        </md-avatar>
        <div class="md-list-text-container">
          <span>
            <router-link :to="{ name: 'SoldiersSong' }">
              Amhrán na bhFiann
            </router-link>
          </span>
          <span class="jpCaption">
            兵士の歌
          </span>
          <p>
            March - March - March
          </p>
        </div>
      </md-list-item>
      <md-list-item>
        <md-avatar
          class="md-large">
          <!-- <router-link :to="{ name: 'Shinano' }">
            <img
              src="/static/img/websitebnr2013.jpg"
              alt="Thumbnail" />
          </router-link> -->
        </md-avatar>
        <div class="md-list-text-container">
          <span>
            <router-link :to="{ name: 'Shinano' }">
              信濃の国
            </router-link>
          </span>
          <span class="jpCaption">
            Shinano-no-kuni
          </span>
          <p>
            March - March - March - March - March - March
          </p>
        </div>
      </md-list-item>
    </md-list>


    <!-- Ceili Board/ケーリーボード, ケーリー情報に改名する -->

    <md-divider></md-divider>

    <div class="event-controller">
      <router-link
        tag="md-button"
        :to="{ name: 'AllEvent' }"
        class="md-raised">過去のイベントをみる</router-link>
      <router-link
        tag="md-button"
        :to="{ name: 'AddEvent' }"
        class="md-raised md-primary">イベントを作成する</router-link>
    </div>

    <p class="page-description">イベントはどなたでも作成することができます。セットダンスに関わるイベントであればご自由にご登録ください。CCÉと自分が参加予定のイベントは城が登録することがあります。もし不都合がありましたら城までご連絡ください。</p>

    <br/>
    <p class="page-description">日本語でかかれたアイリッシュダンスの記事を集めたAndroidアプリ「ダンスノーツ」をリリースしました。よかったらダウンロードしてね！</p>
    <a href='https://play.google.com/store/apps/details?id=jp.setdancepal.irishdancenotes&hl=fa&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target="_blank"><img alt='Google Play で手に入れよう' width="200"　src='https://play.google.com/intl/ja/badges/static/images/badges/ja_badge_web_generic.png'/></a>

    <md-divider></md-divider>

    <footer>
      <!-- セッションのイベントは<a>SeesionGO</a>
      <md-divider></md-divider> -->
      <router-link :to="{ name: 'About' }">
        このサイトについて
      </router-link>
    </footer>

  </div>
</template>

<script>
import db from '../db'
import { getIdFromURL } from 'vue-youtube-embed'

// console.log(db.ref('/sets').val())

export default {
  name: 'setList',
  data () {
    return {
      sets: {},
      articles: {},
      events: {},
      setsWithInitialsHeader: [],
      searchKey: '',
      originalSetList: null,
      subHeaders: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    }
  },
  firebase: {
    news: db.ref('/news'),
    sets: db.ref('/sets'),
    // articles: db.ref('/articles'),
    // articles: db.ref('/articles').orderByChild('timestamp').endAt(Date.parse(new Date())).limitToFirst(3),
    articles: db.ref('/articles').orderByChild('timestamp').limitToLast(3),
    events: db.ref('/events').orderByChild('dateTime').startAt(Date.parse(new Date())).limitToFirst(3)
  },
  computed: {
    getReversedArticles () {
      return this.articles.reverse()
    },
    getNews: function () {
      return this.news && this.news['0'] ? this.news['0']['.value'] : ''
    }
  },
  methods: {
    countTodaysEvent () {
      return this.events.filter(function (event) { return (new Date(event.dateTime).getFullYear() === new Date().getFullYear()) && (new Date(event.dateTime).getMonth() === new Date().getMonth()) && (new Date(event.dateTime).getDate() === new Date().getDate()) }).length
    },
    getEventSchedule: function (startTime, endTime) {
      let zeroFill = require('zero-fill')
      startTime = new Date(startTime)
      endTime = new Date(endTime)
      if ((startTime.getFullYear() === endTime.getFullYear()) && (startTime.getMonth() === endTime.getMonth()) && (startTime.getDate() === endTime.getDate())) {
        return startTime.getFullYear() + '年' + (startTime.getMonth() + 1) + '月' + startTime.getDate() + '日(' + (['日', '月', '火', '水', '木', '金', '土'][new Date(startTime).getDay()]) + ') ' + new Date(startTime).getHours() + ':' + zeroFill(2, new Date(startTime).getMinutes()) + '-' + new Date(endTime).getHours() + ':' + zeroFill(2, new Date(endTime).getMinutes())
      } else if ((startTime.getFullYear() === endTime.getFullYear()) && (startTime.getMonth() === endTime.getMonth())) {
        return startTime.getFullYear() + '年' + (startTime.getMonth() + 1) + '月' + startTime.getDate() + '日(' + (['日', '月', '火', '水', '木', '金', '土'][new Date(startTime).getDay()]) + ') ' + new Date(startTime).getHours() + ':' + zeroFill(2, new Date(startTime).getMinutes()) + '〜' + (endTime.getMonth() + 1) + '月' + endTime.getDate() + '日(' + (['日', '月', '火', '水', '木', '金', '土'][new Date(endTime).getDay()]) + ') ' + new Date(endTime).getHours() + ':' + zeroFill(2, new Date(endTime).getMinutes())
      } else {
        return startTime.getFullYear() + '年' + (startTime.getMonth() + 1) + '月' + startTime.getDate() + '日(' + (['日', '月', '火', '水', '木', '金', '土'][new Date(startTime).getDay()]) + ') ' + new Date(startTime).getHours() + ':' + zeroFill(2, new Date(startTime).getMinutes()) + '〜' + endTime.getFullYear() + '年' + (endTime.getMonth() + 1) + '月' + endTime.getDate() + '日(' + (['日', '月', '火', '水', '木', '金', '土'][new Date(endTime).getDay()]) + ') ' + new Date(endTime).getHours() + ':' + zeroFill(2, new Date(endTime).getMinutes())
      }
    },
    existsSubHeader: function (setName) {
      let initial = setName.substr(0, 1)
      if (this.subHeaders.indexOf(initial) !== -1) {
        this.subHeaders.some(function (element, index, array) {
          if (element === initial) { array.splice(index, 1) }
        })
        this.setsWithInitialsHeader.push(setName)
      }

      return this.setsWithInitialsHeader.indexOf(setName) !== -1
    },
    getAvatar: function (county) {
      // return '/static/img/county/galway.png'
      // return '/static/img/county/' + avatar.toLowerCase()
      return '/static/img/county/' + county + '_Crest.png'
    },
    getThumbnail: function (url) {
      // return 'http://i.ytimg.com/vi/' + getIdFromURL(url) + '/default.jpg'
      return 'https://i.ytimg.com/vi/' + getIdFromURL(url) + '/mqdefault.jpg'
    },
    getDescription: function (set) {
      let orders = []
      let rythmns = []
      let description = ''
      for (let i = 0; i < set.figures.length; i++) {
        // variation のあるフィガーのリズムを重複して表示しないようにする
        if (orders.indexOf(set.figures[i].order) < 0) {
          description += i !== 0 ? ' - ' + set.figures[i].rythmn : set.figures[i].rythmn
          orders.push(set.figures[i].order)
          rythmns.push(set.figures[i].rythmn)
        }
      }

      // すべてのフィガーが同じリズムのとき
      if (Array.from(new Set(rythmns)).length === 1) {
        return 'All ' + Array.from(new Set(rythmns))[0] + 's'
      }

      return description
    },
    searchSet: function (value) {
      if (value !== undefined && value.length > 0) {
        if (this.originalSetList === null) {
          this.originalSetList = this.sets
        }
        this.sets = this.originalSetList.filter(function (set) { return set.name.toLowerCase().indexOf(value.toLowerCase()) >= 0 })
      } else {
        this.sets = this.originalSetList
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

.md-tabs .md-tab {
  padding: 16px 0;
}

.news .md-chip {
  height: auto;
  white-space: normal;
}

p.message {
  margin-bottom: 32px;
  padding: 0 16px;
  color: #888;
}

.md-avatar.md-large {
  width: 113px;
  max-width: 113px;
  min-width: 113px;
}

.md-avatar {
  overflow: inherit;
}

.logo {
  width: 160px;
}
.leading {
    /* display: none; */
    margin: 0 32px;
    margin-bottom: 16px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  /*display: inline-block;*/
  margin: 0 2px;
}

#setList .md-divider {
  margin-left: 18px;
  margin-right: 18px;
}
.jpCaption {
  font-size: 12px;
}

a {
  color: #42b983;
}

.md-chip {
  padding: 10px;
}

.md-chip.type-of-event,
.md-list-item .md-list-item-container .type-of-event {
  font-size: 12px;
}

.event-controller {
  margin-top: 24px;
  margin-bottom: 24px;
}

.event-controller .md-button {
  margin-bottom: 16px;
}

.md-input-container {
  width: 90%;
  margin: 0 16px 16px 16px;
}

footer {
  padding: 24px 0;
}
</style>



// WEBPACK FOOTER //
// Home.vue?064ab32e